import { render, staticRenderFns } from "./CbsChatbot.vue?vue&type=template&id=16539f1b&scoped=true"
import script from "./CbsChatbot.vue?vue&type=script&lang=js"
export * from "./CbsChatbot.vue?vue&type=script&lang=js"
import style0 from "./CbsChatbot.vue?vue&type=style&index=0&id=16539f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16539f1b",
  null
  
)

export default component.exports